import { useDatapointsStore } from '@ContractBuilder/store/datapoints.store';
import { datapointFieldSelector } from '@ContractBuilder/utils/datapoint-field-selector';

import InputSelect from '../InputSelect';

const InputSelectSearchable = (props: any) => {
  'use memo';

  const { ownKey, errors, isRequired } = props;
  const selector = datapointFieldSelector({ ownKey, isRequired, errors });

  const { value, isIncomplete } = useDatapointsStore(selector);

  return (
    <InputSelect {...props} isSearchable value={value} isIncomplete={isIncomplete} dataTestId={props['data-testid']} />
  );
};

export default InputSelectSearchable;
